import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SelectLanguage from "../../../settings/languageSetting";
import { useDispatch } from "react-redux";
import {
  Container,
  Col,
  Row,
  Button,
  Form,
  Spinner,
  InputGroup, // Added for password toggle
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";
import { connect } from "react-redux";
import { getDarkMode } from "../../../store/mode";
import { useHistory } from "react-router-dom";
import { login } from "../../../store/authentication/authSlice";
import logo from "../../../assets/images/logo.png";
import darklogo from "../../../assets/images/logo.jpg";

// Using react-icons (already in your dependencies: "react-icons": "^5.0.1")
import { FiEye, FiEyeOff } from "react-icons/fi";

function mapStateToProps(state) {
  return {
    darkMode: getDarkMode(state),
  };
}

const SignIn = (props) => {
  let history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // State for show/hide password
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError("Please enter both username and password.");
      return;
    }
    setIsSubmitting(true);
    setError(""); // Clear previous errors

    try {
      const credentials = { username, password };
      const response = await dispatch(login(credentials));

      if (response.error) {
        setError(response.error.message || "Login failed. Please try again.");
        return;
      }

      history.push("/");
    } catch (err) {
      setError("An unexpected error occurred.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="login-content">
        <Container className="h-100">
          <Row className="align-items-center justify-content-center h-100">
            <Col md="5">
              <Card className="p-3">
                <Card.Body>
                  <div className="auth-logo">
                    <img
                      src={logo}
                      className={`img-fluid rounded-normal ${
                        !props.darkMode ? "d-none" : ""
                      }`}
                      alt="logo"
                    />
                    <img
                      src={darklogo}
                      className={`img-fluid rounded-normal ${
                        props.darkMode ? "d-none" : ""
                      }`}
                      alt="logo"
                    />
                  </div>

                  <h6 className="mb-3 font-weight-bold text-center">
                    {t("app_title")}
                  </h6>

                  <div className="mb-5">
                    <p className="line-around text-secondary mb-0">
                      <span className="line-around-1">
                        Log in to your account to continue
                      </span>
                    </p>
                  </div>

                  <Form onSubmit={handleLogin}>
                    <Row>
                      {/* Username Field */}
                      <Col lg="12">
                        <Form.Group>
                          <Form.Label className="text-secondary">
                            User name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                          />
                        </Form.Group>
                      </Col>

                      {/* Password Field with Toggle */}
                      <Col lg="12" className="mt-2">
                        <Form.Group>
                          <Form.Label className="text-secondary">
                            Password
                          </Form.Label>

                          <InputGroup>
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              placeholder="Enter Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                            <InputGroup.Text
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}
                              className="bg-light border-left-0"
                            >
                              {showPassword ? (
                                <FiEyeOff size={18} />
                              ) : (
                                <FiEye size={18} />
                              )}
                            </InputGroup.Text>
                          </InputGroup>
                        </Form.Group>

                        {/* Error Message */}
                        {error && (
                          <div className="text-danger mt-2 small">{error}</div>
                        )}
                      </Col>
                    </Row>

                    {/* Submit Button */}
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-block mt-3"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="mr-2"
                          />
                          Logging in...
                        </>
                      ) : (
                        "Log In"
                      )}
                    </Button>

                    {/* Language Options */}
                    <Row className="mt-4">
                      <Col lg="6">
                        <Form.Label>
                          <Link to="/change-language">Change language</Link>
                        </Form.Label>
                      </Col>
                      <Col lg="6" className="text-right">
                        <SelectLanguage />
                      </Col>
                    </Row>
                  </Form>

                  <br />
                  <br />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default connect(mapStateToProps)(SignIn);
